import moment from 'moment';

import {DATETIME_FORMAT} from 'src/constants';

export const parseDate = (str: string) =>
  moment(str).format(DATETIME_FORMAT);
